import React, { useEffect, useState } from "react";
import { Modal } from "../Modal";
import { Form, Input, Space } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { useAuth } from "../../contexts/auth";
import { createNotification } from "../../components";
import { createWorkspace } from "../../services/workspace/api";
import { useNavigate } from "react-router";

export function CreateWorkspaceModal({ open, onCancel, onSubmit }) {
  const intl = useIntl();
  const [form] = Form.useForm();
  const navigate = useNavigate(0);
  const { UpdateWorkspaces, ChangeWorkspace } = useAuth();
  const [name, setName] = useState("");
  const [submittable, setSubmittable] = useState(false);

  const values = Form.useWatch([], form);

  useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [form, values]);


  const submit = () => {
    createWorkspace({name}).then((res) => {
      createNotification("success", intl.formatMessage({id: "modal.workspace.create.success"}));
      UpdateWorkspaces(res.data.workspaces);
      ChangeWorkspace(res.data.external_id);
      onSubmit();
      form.resetFields();
      setTimeout(() => {
        navigate(0);
      }, 400);
    }).catch((err) => {
      console.error(err);
      createNotification("error", intl.formatMessage({id: "modal.workspace.create.error"}))
    });
  }

  return (
    <Modal.Root visible={open}>
      <Modal.Header
        onCancelAction={onCancel}
        title={intl.formatMessage({id: "modal.workspace.create.title"})}
      />
      <Modal.Content align={"start"}>
        <Space
          direction="vertical"
          size="middle"
          style={{
            display: 'flex',
          }}
        >
          <Form layout="vertical" form={form}>
            <Form.Item
              label="Workspace"
              name="name"
              rules={[
                {
                  required: true,
                  message: 'Please input the name!',
                },
                { max: 20 }
              ]}
            >
              <Input
                placeholder={intl.formatMessage({id: "modal.workspace.create.placeholder"})}
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                size="large"
              />
            </Form.Item>
          </Form>
        </Space>
      </Modal.Content>
      <Modal.Actions
        loading={false}
        disabled={!submittable}
        submitText={<FormattedMessage id={"send"} />}
        onSubmitAction={submit}
        onCancelAction={onCancel}
      />
    </Modal.Root>
  );
}
